var map = {
	"./logo-amaysim": "RhMX",
	"./logo-amaysim.svg": "RhMX",
	"./logo-ansto": "1hsU",
	"./logo-ansto.svg": "1hsU",
	"./logo-apra": "rKh7",
	"./logo-apra.svg": "rKh7",
	"./logo-bond": "+Zvo",
	"./logo-bond.svg": "+Zvo",
	"./logo-dcs": "9aXZ",
	"./logo-dcs.svg": "9aXZ",
	"./logo-service-nsw": "69s3",
	"./logo-service-nsw.svg": "69s3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5VIp";